export default __webpack_public_path__ + "static/media/samsung-fridge.e341c561.jpg";